export const statusColors = {
    NAO_ENVIADO: {
        label: 'nao_enviado',
        color: ''
    },
    EM_PREENCHIMENTO: {
        label: 'em_preenchimento',
        color: ''
    },
    ENVIADO: {
        label: 'enviado',
        color: 'warning'
    },
    APROVADO: {
        label: 'aprovado',
        color: 'success'
    },
    REPROVADO: {
        label: 'reprovado',
        color: 'danger'
    },
    CANCELADO: {
        label: 'cancelado',
        color: 'info'
    }
};
